import { useState } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Oreo } from "@/components/Oreo";
import { LangToggle } from "@/components/LangToggle";
import { useLang } from "@/lib/i18n";

export default function Login() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(location.state?.error || "");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data);
      nav("/dashboard");
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
        <div className="relative">
          <div className="label-caps !text-slate-400">Y-ナビ / Y-Navi · Yutaka Navigation</div>
          <h1 className="font-heading text-5xl font-bold mt-4 leading-[1.05]">PQCDSME<br /><span className="text-blue-400">+ Sikap Kerja</span></h1>
          <p className="mt-6 text-slate-300 max-w-md">Tetapkan, delegasikan, monitor, dan evaluasi KPI tahunan dengan breakdown bulanan, review triwulanan YTD, improvement tracking, dan laporan siap meeting.</p>
        </div>
        <div className="relative grid grid-cols-4 gap-3 max-w-md">
          {[["Advance", "bg-cyan-500"], ["On Track", "bg-emerald-500"], ["Delay", "bg-amber-500"], ["Not Achieve", "bg-rose-500"]].map(([l, c]) => (
            <div key={l} className="border border-slate-700 rounded p-3"><div className={`w-2 h-2 rounded-full ${c} mb-2`} /><div className="text-xs text-slate-300">{l}</div></div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-up" data-testid="login-form">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <Oreo mood="semangat" size={56} testId="login-oreo" />
              <div><h2 className="font-heading text-2xl font-bold text-slate-900">{t("masuk")}</h2>
              <p className="text-sm text-slate-500">Gunakan akun yang terdaftar oleh Admin.</p></div>
            </div>
            <LangToggle />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded px-3 py-2">{err}</div>}
          <Button data-testid="login-submit-btn" type="submit" className="w-full" disabled={busy}>{busy ? "Memproses..." : t("masuk_btn")}</Button>
          <div className="relative text-center text-xs text-slate-400"><span className="bg-white px-2 relative z-10">atau</span><div className="absolute inset-x-0 top-1/2 border-t border-slate-200" /></div>
          <Button data-testid="login-google-btn" type="button" variant="outline" className="w-full" onClick={google}>Masuk dengan Google</Button>
        </form>
      </div>
    </div>
  );
}
